export default __webpack_public_path__ + "static/media/61.95dc49b7.png";